import './action-bar.scss';

import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCircle as faSolidCircle, faCogs, faHome } from '@fortawesome/free-solid-svg-icons';
import { MovementDataStore, TaskDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component, Watch } from 'vue-property-decorator';

import { router, Routes } from '../../../router';
import { BarcodeReaderToggle } from './barcode-reader-toggle';
import { UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC } from '../../../busTopics';
import { MapIconToggle } from './map-icon-toggle';

@Component({
    components: {
        sBarcodeReaderToggle: BarcodeReaderToggle,
        sMapIconToggle: MapIconToggle
    },
    template: require('./action-bar.html'),
    props: ['hasItemFocus']
})
export class ActionBar extends ReactiveVue {
    public homeIcon = faHome;
    public menuIcon = faCogs;
    public circleIcon = faCircle;
    public solidCircleIcon = faSolidCircle;
    public $route;

    public movementCount: number = 0;
    public taskCount: number = 0;
    public menuOpened: boolean = false;
    public routeHasMenu: boolean = false;
    public hasItemFocus: boolean;

    public $movementDataStore: MovementDataStore;
    public $taskDataStore: TaskDataStore;

    private COMPONENT_WITH_ACTIVE_SCANNERS = ['movement']

    public created() {
        this.onClick = this.onClick.bind(this);
        this.updateMenuNumber()
        this.subscribeToBus(UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC, this.updateMenuNumber)
    }

    public updateMenuNumber() {
        this.subscribeTo(
            this.$movementDataStore.fetchAll({
                query: { states: MovementDataStore.highlightStates },
                userScope: true,
            }),
            movements => (this.movementCount = movements.length),
            'movements',
        );

        this.subscribeTo(
            this.$taskDataStore.fetchAll({
                query: { states: TaskDataStore.highlightStates },
                userScope: true,
            }),
            tasks => (this.taskCount = tasks.length),
            'tasks',
        );
    }

    public beforeDestroy() {
        super.beforeDestroy();
        this.unsubscribeFromClick();
    }

    public goToTasks() {
        router.push({ name: Routes.TASKS });
    }

    public goToMovements() {
        router.push({ name: Routes.MOVEMENTS });
    }

    public goToContainers() {
        router.push({ name: Routes.CONTAINERS })
    }

    public goToDashboard() {
        router.push({ name: Routes.TRACKING_HOME });
    }

    public toggleMenu(event?: MouseEvent) {
        if (event) {
            event.stopPropagation();
        }
        this.menuOpened = !this.menuOpened;
    }

    private subscribeToClick() {
        document.addEventListener('click', this.onClick);
    }

    private unsubscribeFromClick() {
        document.removeEventListener('click', this.onClick);
    }

    private onClick() {
        if (this.menuOpened) {
            this.menuOpened = false;
        }
    }

    public get canScan(): boolean {
        return this.hasItemFocus && this.COMPONENT_WITH_ACTIVE_SCANNERS.includes(this.$route.name)
    }

    @Watch('$route', { immediate: true, deep: true })
    private onRouteChange($route) {
        this.routeHasMenu = !!$route.matched.find(match => !!match.components.actionMenu);
    }

    @Watch('routeHasMenu', { immediate: false, deep: false })
    private onRouteHasMenuChange(routeHasMenu) {
        if (routeHasMenu) {
            this.subscribeToClick();
        } else {
            this.unsubscribeFromClick();
        }
    }
}
